import React from 'react';
import './FmTag.css';

export interface FmTagProps {
  /**
   * Categorical hue — any CSS colour or `--fm-*` token. Drives the label, the
   * leading dot, and the low-opacity tint background.
   */
  hue: string;
  /** Tag text (kept short; rendered uppercase by the DS). */
  label: React.ReactNode;
  /** Show the leading status dot. Default true. */
  dot?: boolean;
  /**
   * @internal DS-internal className prop; forbidden in route-owned code.
   */
  className?: string;
  'data-testid'?: string;
}

/**
 * FmTag — a quiet categorical tag: a leading status dot + short uppercase label
 * on a low-opacity tint of `hue`. This is the DS replacement for page-local
 * "filled badge" tags. Reusable for operation types, data sources, risk levels,
 * or any status column — change the treatment here once and every consumer
 * transforms with it.
 */
export const FmTag: React.FC<FmTagProps> = ({
  hue,
  label,
  dot = true,
  className,
  'data-testid': dataTestId,
}) => (
  <span
    className={['fm-tag', className].filter(Boolean).join(' ')}
    style={{ ['--fm-tag-hue' as string]: hue }}
    data-testid={dataTestId}
  >
    {dot ? <span className="fm-tag__dot" aria-hidden="true" /> : null}
    {label}
  </span>
);
